import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeneralModalWrapper } from './styles';


class GeneralModal extends Component {
  handleClose = () => {
    const { onClose } = this.props;

    onClose();
  }

  handleAccept = () => {
    const { onAccept, onClose } = this.props;

    onAccept();
    onClose();
  }

  render() {
    const {
      open, type, text, literals,
    } = this.props;

    return (
      <GeneralModalWrapper
        open={open}
        onClose={this.handleClose}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
      >
        <div className='modal general_modal'>
          <div className='general_message'>{text}</div>
          {type === 'select' && (
            <div className='buttons'>
              <button className='primary' type='button' onClick={this.handleAccept}>
                {literals.yes}
              </button>
              <button className='cancel' type='button' onClick={this.handleClose}>
                {literals.no}
              </button>
            </div>
          )}
        </div>
      </GeneralModalWrapper>
    );
  }
}

GeneralModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
  literals: PropTypes.object.isRequired,
};

export default GeneralModal;



// WEBPACK FOOTER //
// ./src/components/GeneralModal/components/index.js